(ns frontend.view.grid.sales-opportunities-grid.view
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.fields.table-column-widths :as widths]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [common.status :as statuses]
   [common.teams :as teams]
   [common.util :as cu]
   [frontend.actions.sales-opportunity :as sales-opportunity-actions]
   [frontend.db :as app-db]
   [frontend.local-storage :as ls]
   [frontend.logging :as logging]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.react.virtualized.scrollable-grid.components :as grid-components]
   [frontend.react.virtualized.scrollable-grid.kanban :as kanban]
   [frontend.react.virtualized.scrollable-grid.view :as scrollable-grid]
   [frontend.react.virtualized.utils :as vu]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.ux-overhaul.listing.pipeline-entity :as pipeline-entity]
   [frontend.ux-overhaul.listing.sales-opportunity.view :as listing-sales-opportunity]
   [frontend.utils :as fu]
   [frontend.view.components.grid-filters.view :as grid-filters]
   [frontend.view.entity :as f-entity]
   [frontend.view.grid.common.components :as components]
   [frontend.view.grid.common.utils :as grid-utils]
   [frontend.view.grid.sales-opportunities-grid.db :as db]
   [frontend.view.grid.sales-opportunities-grid.events :as events]
   [frontend.view.modals.bulk-edit-entity.view :as bulk-edit-modal]
   [frontend.view.modals.curtains.pipeline-settings-curtain.view :as pipeline-settings-curtain]
   [frontend.view.modals.curtains.sales-opportunity.lost-curtain :as lost-curtain]
   [frontend.view.modals.curtains.sales-opportunity.on-hold-curtain :as on-hold-curtain]
   [frontend.view.modals.curtains.tenant-custom-filter-curtain.view :as
    tenant-custom-filter-curtain]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.folder-management-check-lists-modal.view :as folder-management-check-lists-modal]
   [frontend.view.modals.folder-management-modal.view :as folder-management-modal]
   [frontend.view.named-view.events :as named-view-events]
   [frontend.view.not-found :as not-found]
   [potpuri.core :as potpuri]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.editors.entity-creator.view :as creator-editor]
   [ui.modals.entity-selector.view :as entity-selector]
   [frontend.page-components.navbar-components.create-dropdown :as create-dropdown]))

(defonce select-width 30)

(defn column
  [args]
  (let [{:keys [label attribute field-schema filter-data sorting-disabled? width hover-atom
                recompute-grid-sizes! flex-grow]}
        args
        default-width (-> (widths/get-column-width attribute)
                          :default-width
                          (or widths/default-width))]
    {:label               label
     :data-key            attribute
     :field-schema        field-schema
     :filter-data         filter-data
     :update-filter!      (fn [k filter-data]
                            (grid/set-filter (events/setup-args) k filter-data))
     :sort-disabled?      (boolean sorting-disabled?)
     :min-width           (-> (widths/get-column-width attribute)
                              :min-width
                              (or widths/min-width))
     :max-width           (-> (widths/get-column-width attribute)
                              :max-width
                              (or widths/max-width))
     :default-width       default-width
     :width               (or width default-width)
     :set-width           width
     :begin-width-update! (partial grid/begin-width-update! hover-atom attribute)
     :update-width!
     (partial grid/update-width! (events/setup-args) recompute-grid-sizes! hover-atom attribute)
     :end-width-update!   (partial grid/end-width-update! hover-atom attribute)
     :get-styling         (partial grid/get-styling hover-atom attribute)
     :flex-grow           flex-grow}))

(defn toolbar-actions
  [{:keys [view-mode]}]
  (let [all-teams (->> @session/all-teams
                       (remove :common/disabled?))
        account-teams (teams/resolve-account-teams @session/account all-teams)]
    [{:toolbar-button?  true
      :dropdown-action? true
      :hidden?          (fn []
                          (= view-mode :board-mode))
      :ord              2
      :primary-button?  false
      :add-ellipsis?    true
      :on-select        (fn [_e]
                          (grid/open-select-columns-curtain (events/setup-args)))
      :label            (if (= view-mode :board-mode)
                          (loc/tr :select-columns)
                          (loc/tr :action/select-columns))}
     (grid-utils/export-button {:account-teams  account-teams
                                :button-ord     3
                                :grid-state     db/sales-opportunities
                                :column-keys-fn events/resolve-column-keys})

     (when (and (not (session/is-read-only-user?))
                (not (session/sales-oppo-creation-flow?)))
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              1
        :icon             :fa-plus
        :primary-button?  true
        :on-select        (fn [_e]
                            (f-entity/open-creator! :entity.type/sales-opportunity {}))
        :label            (loc/tr :sales-opportunity-add-button)})

     (when (and (session/sales-oppo-creation-flow?)
                (not (session/is-read-only-user?)))
       {:toolbar-button?  true
        :dropdown-action? true
        :ord              1
        :icon             :fa-plus
        :primary-button?  true
        :sub-menu-side    :left
        :items
        (let [pipeline-id @session/selected-sales-oppo-pipeline
              pipeline @(r/track session/get-entity pipeline-id)
              items (create-dropdown/pipeline-stage-items
                     {:entity-type :entity.type/sales-opportunity
                      :pipeline pipeline})]
          items)
        :label (loc/tr :sales-opportunity-add-button)})

     (when (session/is-admin?)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              10
        :add-ellipsis?    true
        :label            (loc/tr :pipeline-stages)
        :primary-button?  true
        :on-select        (fn [_e]
                            (modals/open-modal!
                             pipeline-settings-curtain/modal-key
                             {:pipeline-id          @session/selected-sales-oppo-pipeline
                              :stage-entity-type    :entity.type/sales-opportunity-stage
                              :stage-name-attribute :sales-opportunity-stage/name
                              :pipeline-attribute   :sales-opportunity-stage/pipeline}))})
     (when (session/is-admin?)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              12
        :add-ellipsis?    true
        :label            (loc/tr :pipeline-folders)
        :primary-button?  true
        :on-select        (fn [_e]
                            (modals/open-modal!
                             folder-management-modal/modal-key
                             {:entity @session/selected-sales-oppo-pipeline-entity}))})
     (when (and (session/is-admin?)
                (not (session/is-read-only-user?)))
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              13
        :add-ellipsis?    true
        :label            (loc/tr :pipeline-checklists)
        :primary-button?  true
        :on-select        (fn [_e]
                            (modals/open-modal!
                             folder-management-check-lists-modal/modal-key
                             {:entity           @session/selected-sales-oppo-pipeline-entity
                              :check-lists-atom session/check-lists}))})
     {:divider? true
      :dropdown-action? true
      :ord 14}

     (grid-utils/creator-config-item
      {:ord 15
       :entity-type :entity.type/sales-opportunity
       :pipeline @(r/track session/get-entity @session/selected-sales-oppo-pipeline)})

     (when (= view-mode :board-mode)
       {:toolbar-button?  false
        :dropdown-action? true
        :ord              16
        :add-ellipsis?    true
        :label            (loc/tr :card-settings)
        :on-select        (fn [_e]
                            (events/open-card-settings!))})

     {:divider? true
      :dropdown-action? true
      :ord 17}

     (grid-utils/preferred-landing-page-toggle {:view-id :sales-opportunities-grid
                                                :pipeline-id @session/selected-sales-oppo-pipeline
                                                :pipeline-key :sales-opportunity-pipeline})]))

(defn toolbar-buttons-renderer
  []
  (let [setup-args (events/setup-args)
        modal-atom (:modal-state setup-args)
        open-bulk-edit! #(swap! modal-atom assoc :bulk-edit-modal true)
        selected (grid/get-selected-items setup-args)]
    [:div
     {:class "flex gap-2"}
     (if (session/is-read-only-user?)
       [:span (loc/tr :no-grid-actions-for-read-only-user)]
       [:<>
        [components/toolbar-delete-button
         {:max-delete-count   10000
          :selected-items     (grid/get-selected-items setup-args)
          :on-delete-clicked! events/delete-selected-clicked}]
        [components/toolbar-bulk-edit-button
         {:max-bulk-edit-count   10000
          :selected-items        selected
          :on-bulk-edit-clicked! open-bulk-edit!}]])]))

(defn open-lost-curtain!
  [{:keys [entity reset-focus!]}]
  (when (session/is-mobile?)
    (.scrollTo js/window 0 0))
  (modals/open-modal!
   lost-curtain/modal-key
   {:sales-opportunity-id (:db/id entity)
    :reset-focus!         reset-focus!}))

(defn open-on-hold-curtain!
  [{:keys [entity reset-focus!]}]
  (when (session/is-mobile?)
    (.scrollTo js/window 0 0))
  (modals/open-modal!
   on-hold-curtain/modal-key
   {:sales-opportunity-id (:db/id entity)
    :reset-focus!         reset-focus!}))

(defn status-options
  [entity]
  (->> statuses/sales-opportunity-status-options
       (remove
        (fn [status]
          (cond
            (= (:sales-opportunity/status entity) :sales-opportunity.status/won)
            (some #{(:key status)}
                  [:sales-opportunity.status/won
                   :sales-opportunity.status/on-hold
                   :sales-opportunity.status/lost])

            (= (:sales-opportunity/status entity) :sales-opportunity.status/lost)
            (some #{(:key status)}
                  [:sales-opportunity.status/won :sales-opportunity.status/lost])

            (= (:sales-opportunity/status entity) :sales-opportunity.status/on-hold)
            (some #{(:key status)}
                  [:sales-opportunity.status/won :sales-opportunity.status/on-hold])

            (= (:sales-opportunity/status entity) :sales-opportunity.status/active)
            (= (:key status) :sales-opportunity.status/active))))))

(defn change-status!
  [{:keys [entity new-value reset-focus!]}]
  (let [lost? (and (= new-value :sales-opportunity.status/lost)
                   (some #{(:sales-opportunity/status entity)}
                         [:sales-opportunity.status/active :sales-opportunity.status/on-hold]))
        on-hold? (and (= new-value :sales-opportunity.status/on-hold)
                      (some #{(:sales-opportunity/status entity)}
                            [:sales-opportunity.status/active :sales-opportunity.status/lost]))
        won? (and (= new-value :sales-opportunity.status/won)
                  (some #{(:sales-opportunity/status entity)} [:sales-opportunity.status/active]))
        resurrect? (and (= new-value :sales-opportunity.status/active)
                        (some #{(:sales-opportunity/status entity)}
                              [:sales-opportunity.status/won
                               :sales-opportunity.status/on-hold
                               :sales-opportunity.status/lost]))]
    (cond
      lost?
      (open-lost-curtain! {:entity       entity
                           :reset-focus! reset-focus!})

      on-hold?
      (open-on-hold-curtain! {:entity       entity
                              :reset-focus! reset-focus!})

      won?
      (events/won! {:entity       entity
                    :reset-focus! reset-focus!})

      resurrect?
      (do
        (sales-opportunity-actions/*->resurrect!
         {:sales-opportunity-id (:db/id entity)}
         identity
         (partial logging/error "Failed to set sales opportunity as active "))
        (when reset-focus!
          (reset-focus!)))

      :else nil)))

(defn create-props-atom
  [selected sorted-grid-entities filters grid-store
   recompute-grid-sizes! hover-atom modal-atom pipeline]
  (let [tenant-schema @session/tenant-schema
        columns
        (vec (keep (fn [k]
                     (let [field-schema (registry/get-field-schema tenant-schema k)
                           label (events/get-label k)]
                       (column {:label                 label
                                :attribute             k
                                :field-schema          field-schema
                                :filter-data           (get filters k)
                                :sorting-disabled?     false
                                :width                 (grid/get-saved-width (events/setup-args) k)
                                :hover-atom            hover-atom
                                :recompute-grid-sizes! recompute-grid-sizes!
                                :flex-grow             1})))
                   (events/resolve-column-keys)))
        editable-grid? (and (session/has-feature-access? :feature/editable-grid)
                            @session/editable-grid?)]
    (r/atom
     {:grid-store              grid-store
      :pipeline                pipeline
      :setup-args              (events/setup-args)
      :recalculate!            #(grid/recalculate (events/setup-args))
      :grid-entities           sorted-grid-entities
      :grid-entity-ids         (->> sorted-grid-entities
                                    (mapv :db/id)
                                    (into #{}))
      :selected                selected
      :link-to-entity-field    :sales-opportunity/name
      :header-height           50
      :editable-grid?          editable-grid?
      :select-width            select-width
      :min-columns-width       30
      :height                  (- (or (:height @app-db/window) 400)
                                  (or (:fixed-navbars-height @app-db/window) 0)
                                  75)                                                               ;; TODO: lazy - fixed 120px for button row in this view
      :avail-height            (- (or (:height @app-db/window) 400)
                                  (or (:fixed-navbars-height @app-db/window) 0)
                                  75)                                                               ;; TODO: lazy - fixed 120px for button row in this view
      :useDynamicRowHeight     false                                                                ;; TODO: kebab-case
      :row-height              40                                                                   ;(fn [index] 40)
      :row-count               (if (sequential? sorted-grid-entities)
                                 (count sorted-grid-entities)
                                 0)
      :scrollToIndex           0
      :overscan-count          1
      :columns                 columns
      :no-rows-renderer        (r/partial grid/default-no-rows-render
                                          @db/sales-opportunities
                                          :entity.type/sales-opportunity)
      :read-only-fields        [:sales-opportunity/on-hold-until
                                :sales-opportunity/on-hold-comment
                                :sales-opportunity/on-hold
                                :sales-opportunity/put-on-hold
                                :sales-opportunity/put-on-hold-on
                                :sales-opportunity/lost-comment
                                :sales-opportunity/lost-on
                                :sales-opportunity/won-on
                                :sales-opportunity/agreement
                                :sales-opportunity/pipeline]
      :pipeline-key            :sales-opportunity/pipeline
      :owner-key               :sales-opportunity/owner
      :status-key              :sales-opportunity/status
      :status-options          status-options
      :on-row-click!           (fn [row]
                                 (let [data (when (< row (count sorted-grid-entities))
                                              (nth sorted-grid-entities row))]
                                   (routing/open-entity (:db/id data))))
      :on-cell-click           (fn [row col]
                                 (grid/handle-cell-click!
                                  {:columns              columns
                                   :col                  col
                                   :row                  row
                                   :sorted-grid-entities sorted-grid-entities
                                   :state                hover-atom}))
      :change-status!          change-status!
      :is-sorted-by?           (partial grid/is-sorted-by db/view-settings)
      :is-secondary-sorted-by? (partial grid/is-secondary-sorted-by db/view-settings)
      :sort-by!                (fn [k dir]
                                 (grid/set-sort-by (events/setup-args) k dir))
      :reorder-columns!        (fn [dragged-column after-column]
                                 (grid/reorder-columns! (events/setup-args)
                                                        dragged-column
                                                        after-column))
      :can-filter?             (fn [_k]
                                 true)
      :resizing-column         (some-> @hover-atom
                                       (get :resize-start-width)
                                       (first)
                                       (key))
      :recompute-grid-sizes!   recompute-grid-sizes!
      :all-selection!          (fn []
                                 (let [selected (:selected @db/sales-opportunities)]
                                   (if (or (= :all selected) (not-empty selected))
                                     (grid/clear-selection! (events/setup-args))
                                     (swap! db/sales-opportunities assoc :selected :all))))
      :select-action-renderer  toolbar-buttons-renderer
      :on-row-select!          (fn [index checked]
                                 (let [data (when (< index (count sorted-grid-entities))
                                              (nth sorted-grid-entities index))
                                       sales-opportunity-id (:db/id data)]
                                   (if (= selected :all)
                                     (grid/select-all-but (events/setup-args) sales-opportunity-id)
                                     (if (boolean checked)
                                       (swap! db/sales-opportunities assoc-in
                                              [:selected sales-opportunity-id]
                                              true)
                                       (swap! db/sales-opportunities potpuri/dissoc-in
                                              [:selected sales-opportunity-id])))))
      :deselect-entity!        (fn [entity-id]
                                 (if (= selected :all)
                                   (grid/select-all-but (events/setup-args) entity-id)
                                   (swap! db/sales-opportunities potpuri/dissoc-in [:selected entity-id])))
      :row-data-getter
      (fn [index]
        (let [data (when (< index (count sorted-grid-entities))
                     (nth sorted-grid-entities index))]
          (merge {:selected            (or (= selected :all)
                                           (get (:selected @db/sales-opportunities) (:db/id data)))
                  :tooltip-text-getter (fn [data-key]
                                         (when (and (= data-key :sales-opportunity/customer)
                                                    (:sales-opportunity/customer data))
                                           (loc/tr :click-to-open)))}
                 data)))

      :new-action-view         {:in-use?         true
                                :open-bulk-edit! #(swap! modal-atom assoc :bulk-edit-modal true)
                                :bulk-delete!    events/delete-selected-clicked
                                :modal-atom      modal-atom}})))

(defn render
  [grid-store _view-mode]
  (let [hover-atom (r/atom {:hover {:col nil :row nil}})

        entity-type :entity.type/sales-opportunity

        ;;for saving grid references:
        recompute-grid-sizes! (fn []
                                (js/setTimeout
                                 (partial vu/recompute-grid-sizes-with-state! grid-store)
                                 0))]
    (fn [view-mode]
      (let [tenant-schema @session/tenant-schema
            selected (:selected @db/sales-opportunities)
            filters @db/sales-opportunity-filters
            all-columns (events/resolve-column-key-universe)
            sorted-grid-entities (:sorted-grid-entities @db/sales-opportunities)
            setup-args @(r/track events/setup-args)
            modal-atom (:modal-state setup-args)
            pipeline @session/selected-sales-oppo-pipeline-entity
            grid-atom (create-props-atom selected
                                         sorted-grid-entities
                                         filters
                                         grid-store
                                         recompute-grid-sizes!
                                         hover-atom
                                         modal-atom
                                         pipeline)
            card-settings? (:card-settings? @db/kanban)
            show-quick-filters? (:show-quick-filters? @db/sales-opportunities)
            show-bulk-edit-modal? (:bulk-edit-modal @modal-atom)

            filters-props {:pipeline-id                  @session/selected-sales-oppo-pipeline
                           :minimized?                   (not show-quick-filters?)
                           :tenant-custom-filter-options (when (tenant-customizations/capman?)
                                                           [{:value :custom-filter-sales-investor-contact-country
                                                             :label (loc/tr :custom-filter-sales-investor-contact-country)}])
                           :hide-maximize?               true
                           :universal-search?            true
                           :search-placeholder           (loc/tr :search-for-a-sales-opportunity)
                           :setup-args                   (events/setup-args)
                           :set-universal-search!        (r/partial grid/set-universal-search! setup-args)
                           :set-name-search!             (r/partial grid/set-name-search! setup-args)
                           :hide-named-views?            true
                           :named-views                  (events/named-views)
                           :current-view                 @db/view-settings
                           :columns                      (events/resolve-column-keys)
                           :all-columns                  all-columns
                           :get-column-label             events/get-label
                           :set-filter!                  (fn [k filter-data]
                                                           (grid/set-filter (events/setup-args) k filter-data))
                           :edit-custom-filter!
                           (fn [k filter-data]
                             (case k
                               :custom-filter-sales-investor-contact-country
                               (modals/open-modal!
                                tenant-custom-filter-curtain/modal-key
                                (merge
                                 filter-data
                                 {:on-ok!
                                  (fn [args]
                                    (grid/set-filter
                                     (events/setup-args)
                                     :custom-filter-sales-investor-contact-country
                                     (merge
                                      {:label (if (:selected-cities args)
                                                (loc/tr
                                                  :custom-filter-sales-investor-contact-country-and-city-label
                                                  [(string/join ", " (:selected-countries args))
                                                   (string/join ", " (:selected-cities args))])
                                                (loc/tr
                                                  :custom-filter-sales-investor-contact-country-label
                                                  [(string/join ", " (:selected-countries args))]))}
                                      args)))}))
                               nil))
                           :edit-filter!
                           (fn [k filter-data]
                             (grid/open-filter-curtain
                              {:field-key      k
                               :field-schema   (registry/get-field-schema tenant-schema k)
                               :field-label-fn events/get-label
                               :pipeline       pipeline
                               :options        (->> all-columns
                                                    (map (juxt identity
                                                               (partial registry/get-field-schema
                                                                        tenant-schema))))
                               :current-filter filter-data
                               :update-fn!     (fn [k filter-data]
                                                 (grid/set-filter (events/setup-args) k filter-data))}
                              nil))
                           :hide-qf-attributes           [:sales-opportunity/customer
                                                          :sales-opportunity/pipeline
                                                          [:sales-opportunity/customer :investor/name]
                                                          [:sales-opportunity/customer :investor/owner]]
                           :load-view!                   (fn [named-view]
                                                           (events/load-view! named-view)
                                                           (grid/clear-selection! {:state db/sales-opportunities}))
                           :save-view!                   events/save-current-view!
                           :delete-view!                 named-view-events/delete-view!
                           :toggle-minimize!             (fn []
                                                           (events/toggle-quick-filters!)
                                                           (.setTimeout js/window recompute-grid-sizes! 1000))}]
        (if card-settings?
          [kanban/card-settings-view (events/setup-args)]
          [:<>
           [grid-filters/view
            filters-props]
           [creator-editor/modal-view]
           [:div.grid-view
            {:class "flex flex-1 ps-4"}
            [:div
             {:class-name (fu/cs "grid-view-content"
                                 (when-not show-quick-filters? "named-views-minimized")
                                 (when (= view-mode :board-mode) "board-view"))}

             (when show-bulk-edit-modal?
               [bulk-edit-modal/view
                {:setup-args   setup-args
                 :entity-type  entity-type
                 :close-modal! #(swap! modal-atom dissoc :bulk-edit-modal)}])

             (if (= view-mode :board-mode)
               [kanban/view
                {:setup-args   (events/setup-args)
                 :card-classes (fn [sales-opportunity]
                                 (case (:sales-opportunity/status sales-opportunity)
                                   :sales-opportunity.status/active "status-active"
                                   :sales-opportunity.status/on-hold "border-warning-regular"
                                   :sales-opportunity.status/lost "border-danger-light-border"
                                   :sales-opportunity.status/won "border-base-light-border-accent"
                                   "status-unknown"))
                 :card-actions (concat
                                [(kanban/open-entity-action
                                  {:entity-type :entity.type/sales-opportunity})]
                                (when-not (session/is-read-only-user?)
                                  [{:id         "pass-sales-opportunity"
                                    :label      (loc/tr :pipeline-card-lost-action)
                                    :icon       "fal fa-ban"
                                    :hidden?    (fn [{:keys [entity]}]
                                                  (not (some #{(:sales-opportunity/status entity)}
                                                             [:sales-opportunity.status/active
                                                              :sales-opportunity.status/on-hold])))
                                    :on-select! open-lost-curtain!}
                                   {:id         "put-sales-opportunity-on-hold"
                                    :label      (loc/tr :pipeline-card-put-on-hold-action)
                                    :icon       "fal fa-pause-circle"
                                    :hidden?    (fn [{:keys [entity]}]
                                                  (not (some #{(:sales-opportunity/status entity)}
                                                             [:sales-opportunity.status/active
                                                              :sales-opportunity.status/lost])))
                                    :on-select! open-on-hold-curtain!}
                                   {:id         "won-action"
                                    :label      (loc/tr :pipeline-card-won-agreement)
                                    :icon       "fal fa-check"
                                    :hidden?    (fn [{:keys [entity]}]
                                                  (not (some #{(:sales-opportunity/status entity)}
                                                             [:sales-opportunity.status/active])))
                                    :on-select! (fn [{:keys [entity]}]
                                                  (events/won! {:entity entity}))}
                                   {:id      "reactivate-sales-opportunity"
                                    :label   (loc/tr :pipeline-card-reactivate-action)
                                    :icon    "fal fa-redo-alt"
                                    :hidden? (fn [{:keys [entity _recompute-all!]}]
                                               (not (some #{(:sales-opportunity/status entity)}
                                                          [:sales-opportunity.status/won
                                                           :sales-opportunity.status/on-hold
                                                           :sales-opportunity.status/lost])))
                                    :on-select!
                                    (fn [{:keys [entity]}]
                                      (sales-opportunity-actions/*->resurrect!
                                       {:sales-opportunity-id (:db/id entity)}
                                       identity
                                       (partial logging/error
                                                "Failed to set sales opportunity as active ")))}]))}]
               [scrollable-grid/view
                {:props-atom grid-atom
                 :hover-atom hover-atom}])]]])))))

(defn toolbar
  [args]
  (let [view-mode (or (:view-mode @db/view-settings)
                      (:view-mode (ls/get-in (events/ls-path)))
                      (:initial-mode args)
                      :board-mode)
        board-mode? (= view-mode :board-mode)
        card-mode (or (:card-mode @db/kanban)
                      :short-card)
        has-empty-groups? (when board-mode?
                            (kanban/has-empty-groups? @(r/track events/setup-args)))
        pipelines (->> @session/all-sales-oppo-pipelines
                       (filter session/has-entity-access?)
                       (remove :common/disabled?)
                       (remove :pipeline/inactive?))
        selected-pipeline-name (->> @session/selected-sales-oppo-pipeline
                                    (get @session/entities)
                                    (entity/display-string))]
    [:div
     {:class "px-4 py-1 flex items-center justify-between
                   bg-base-light
                   border-b border-solid border-base-light-border-paler"}
     [:div
      {:class "w-full flex justify-between gap-6"}
      [:div
       [:div
        {:class "flex gap-2 items-center"}
        (if (and (cu/multiple? pipelines)
                 @session/selected-sales-oppo-pipeline)
          [grid-components/pipeline-selector
           {:pipelines            pipelines
            :view-text            selected-pipeline-name
            :select-pipeline!     (fn [id]
                                    (session/set-module! :module/sales-pipelines)
                                    (swap! session/selected-pipelines assoc
                                           :sales-opportunity-pipeline
                                           id)
                                    (routing/set-view! [:sales-opportunities-grid-with-pipeline :pipeline-id id]))
            :selected-pipeline-id @session/selected-sales-oppo-pipeline}]
          [:div
           {:class-name (fu/cs "toolbar-selected-pipeline")}
           [:label
            {:class "font-semibold"}
            selected-pipeline-name]])
        [:span
         {:class "h-5 px-2 flex items-center justify-center text-xs font-semibold text-base-light-text bg-complement-regular rounded-full"}
         (count @db/sorted-kanban-entities)]

        [grid-components/named-view-selector
         {:named-views               (events/named-views)
          :current-view              @db/view-settings
          :load-view!                (fn [id]
                                       (events/load-view! (events/named-view-by-id id))
                                       (grid/clear-selection! {:state db/sales-opportunities}))
          :delete-view!              named-view-events/start-delete-view!
          :accounts-with-view-access (session/active-accounts-with-pipeline-access
                                      @session/selected-sales-oppo-pipeline)
          :save-current-view!        events/save-current-view!}]

        (when board-mode?
          [grid-components/sort-selector
           {:view-settings   @db/view-settings
            :entity-type     :entity.type/sales-opportunity
            :sortable-fields (events/resolve-column-key-universe)
            :set-sort-by!    (fn [k dir]
                               (grid/set-sort-by (events/setup-args) k dir))}])

        (when board-mode?
          [grid-components/grouped-by-selector
           {:view-settings      @db/view-settings
            :entity-type        :entity.type/sales-opportunity
            :default-grouped-by :sales-opportunity/stage
            :grouped-by-fields  (->> (events/resolve-column-key-universe)
                                     (remove #{:sales-opportunity/status})
                                     (filter grid/groupable-attribute?))
            :set-grouped-by!    (fn [k]
                                  (swap! db/view-settings assoc :grouped-by k)
                                  (ls/update-in (events/ls-path)
                                                assoc
                                                :grouped-by
                                                k))}])]]

      [:div
       {:class "flex gap-2 items-center"}
       ;(when-not board-mode?
       ;  [grid-components/editable-grid-toggle])
       (when (and board-mode? (not= card-mode :short-card))
         [button/square-secondary-open
          {:on-click (fn [_] (events/collapse-all!))
           :tooltip  (loc/tr :collapse-all)}
          [:i.fal.fa-compress-alt]])
       (when (and board-mode? (= card-mode :short-card))
         [button/square-secondary-open
          {:tooltip  (loc/tr :expand-all)
           :on-click (fn [_] (events/expand-all!))}
          [:i.fal.fa-expand-alt]])

       [button/square-secondary-open
        {:tooltip  (grid-components/view-mode-tooltip board-mode?)
         :on-click (fn [_]
                     (events/switch-mode! view-mode))}
        (if board-mode?
          [:i.fal.fa-table]
          [:i.fal.fa-signal-3.fa-rotate-180.kanban-icon])]

       (when (and board-mode? has-empty-groups?)
         [grid-utils/hide-empty-kanban-groups-toggle "sales-opportunities-grid-toolbar" db/kanban])

       [:div.toolbar-dropdown
        (zap-toolbar/dropdown (->> (toolbar-actions {:view-mode view-mode})
                                   (filter :dropdown-action?)
                                   (remove (fn [{:keys [hidden?]}]
                                             (when (fn? hidden?)
                                               (hidden?))))
                                   (sort-by :ord))
                              true)]]]]))

(defn view
  [_args]
  (let [grid-store (atom {})
        close-atom (atom false)
        resizer (fn []
                  (js/setTimeout (partial vu/recompute-grid-sizes-with-state! grid-store) 100))]
    (.addEventListener js/window "resize" resizer)
    (r/create-class
     {:component-did-mount    (fn []
                                (fu/timeout 10 (partial events/setup close-atom)))
      :component-will-unmount (fn []
                                (reset! close-atom true)
                                (events/cleanup)
                                (.removeEventListener js/window "resize" resizer))
      :reagent-render         (partial render grid-store)})))

(defmethod routing/render-view :sales-opportunities-grid
  [{:keys [initial-mode route-params] :as args}]
  (session/sync-selected-pipeline-from-route!
   {:route-params            route-params
    :pipeline-key            :sales-opportunity-pipeline
    :all-pipelines-for-type  session/all-sales-oppo-pipelines})
  (if (session/new-grid-2023?)
    [pipeline-entity/render-page listing-sales-opportunity/config]
    (let [forbidden? (or (not (session/sales-pipelines?))
                         (and (not (session/is-admin?))
                              (->> @session/all-sales-oppo-pipelines
                                   (filter session/has-entity-access?)
                                   (empty?))))
          no-pipeline-in-use? (and (session/dealflow?)
                                   (session/is-admin?)
                                   (->> @session/all-sales-oppo-pipelines
                                        (every? :pipeline/inactive?)))
          view-mode (or (:view-mode @db/view-settings)
                        (:view-mode (ls/get-in (events/ls-path)))
                        initial-mode
                        :board-mode)]
      (cond
        forbidden?
        [not-found/not-found-view]
        no-pipeline-in-use?
        [components/no-pipelines-in-use-view]
        :else
        [default-page-layout/view
         [:<>
          (when (:won-modal-open? @db/won-modal*)
            [entity-selector/view
             {:title                  (loc/tr :select-or-create-agreement)
            :entity-types           [:entity.type/sale-agreement]
            :new-entity-start-value (events/agreement-start-value (:won-modal-entity @db/won-modal*))
            :label                  (loc/tr :entity.type/sale-agreement)
            :on-select!             (fn [agreement-id]
                                      (when-let [reset-focus! (:reset-focus! @db/won-modal*)]
                                        (when (fn? reset-focus!)
                                          (try
                                            (reset-focus!)
                                            (catch js/Object _err))))
                                      (let [sales-opportunity (:won-modal-entity @db/won-modal*)]
                                        (swap! db/won-modal* assoc
                                               :won-modal-open? false
                                               :won-modal-entity nil
                                               :reset-focus! nil)
                                        (sales-opportunity-actions/*->won!
                                         {:sales-opportunity-id (:db/id sales-opportunity)
                                          :sale-agreement-id    agreement-id}
                                         (fn [_])
                                         (fn [err]
                                           (logging/error "Failed to set sales oppo as Won " err)))))
            :on-cancel!             (fn [_]
                                      (when-let [reset-focus! (:reset-focus! @db/won-modal*)]
                                        (when (fn? reset-focus!)
                                          (reset-focus!)))
                                      (swap! db/won-modal* assoc
                                             :won-modal-open? false
                                             :won-modal-entity nil
                                             :reset-focus! nil))}])
        [components/card-settings-toolbar
         [toolbar args] db/kanban events/close-card-settings!]
          [view view-mode]]]))))
